export enum TimezoneMode {
    LEAD = 'lead',
    BUSINESS = 'business',
}

export enum FallbackAction {
    MARK_INACTIVE = 'mark_inactive',
    ESCALATE_TO_HUMAN = 'escalate_to_human',
}

export interface AutomationConfig {
    id?: number;
    userId?: string;
    maxAttempts: number;
    attemptIntervalsDays: number[];
    businessHoursStart: string; // HH:MM
    businessHoursEnd: string;   // HH:MM
    slotDuration?: number;      // minutes, default 30
    timezoneMode: TimezoneMode;
    fallbackAction: FallbackAction;
    standardMessageTemplate: string;
    bookingEnabled: boolean;
    bookingLink?: string;
    updatedAt?: string;
}
